package com.tovtalk.ui.screen.onboarding

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tovtalk.domain.entity.KosherLevel
import com.tovtalk.domain.entity.resolvedName
import com.tovtalk.ui.theme.TovTalkBrand
import com.tovtalk.utils.strings.StringProvider

@Composable
fun KashrutLevelScreen(
    levels: List<KosherLevel>,
    selectedId: Int?,
    onSelect: (Int) -> Unit,
    onAdvance: () -> Unit,
    onBack: (() -> Unit)? = null,
) {
    OnboardingLayout(
        progressCurrent = 2,
        progressTotal = 4,
        onSkip = onAdvance,
        onBack = onBack,
        ctaText = StringProvider.get("onboarding_common_continue"),
        onCta = onAdvance,
        ctaEnabled = selectedId != null,
        headerContent = {
            OnboardingHeader(
                eyebrow = StringProvider.get("onboarding_step_label_2_of_4"),
                title = StringProvider.get("onboarding_kashrut_title"),
                subtitle = StringProvider.get("onboarding_kashrut_subtitle"),
            )
        },
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp, vertical = 16.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp),
        ) {
            levels.forEach { level ->
                KashrutLevelCard(
                    level = level,
                    selected = level.id == selectedId,
                    onClick = { onSelect(level.id) },
                )
            }
        }
    }
}

@Composable
private fun KashrutLevelCard(
    level: KosherLevel,
    selected: Boolean,
    onClick: () -> Unit,
) {
    val bg = if (selected) TovTalkBrand.copy(alpha = 0.08f) else Color.White.copy(alpha = 0.06f)
    val borderColor = if (selected) TovTalkBrand else Color.White.copy(alpha = 0.10f)
    val shape = RoundedCornerShape(14.dp)

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(shape)
            .background(bg)
            .border(width = if (selected) 2.dp else 1.dp, color = borderColor, shape = shape)
            .clickable(onClick = onClick)
            .padding(horizontal = 16.dp, vertical = 14.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        RadioIndicator(selected = selected)
        Spacer(Modifier.width(14.dp))
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = level.resolvedName("he"),
                color = Color.White,
                fontSize = 15.sp,
                fontWeight = FontWeight.SemiBold,
            )
            val description = level.descriptionKey?.let { StringProvider.get(it) }
            if (!description.isNullOrBlank()) {
                Spacer(Modifier.height(3.dp))
                Text(
                    text = description,
                    color = Color.White.copy(alpha = 0.55f),
                    fontSize = 12.sp,
                )
            }
        }
    }
}
